/** Singular/plural count copy for customer-facing operational labels. */

export function formatCountNoun(
  count: number,
  singular: string,
  plural: string = `${singular}s`,
): string {
  const n = Math.max(0, Math.trunc(Number(count) || 0));
  const noun = n === 1 ? singular : plural;
  return `${n.toLocaleString()} ${noun}`;
}

export function formatObservationCount(count: number): string {
  return formatCountNoun(count, 'observation');
}

export function formatEpisodeCount(count: number): string {
  return formatCountNoun(count, 'episode');
}

export function formatEventCount(count: number): string {
  return formatCountNoun(count, 'event');
}

export function formatWindowCount(count: number): string {
  return formatCountNoun(count, 'window');
}
